'use client'

import clsx from 'clsx'
import { cx } from 'utils/cx'

import { Action, type ActionProps } from './Action'

import styles from './ContentContainer.module.scss'

interface ContentContainerProps {
	readonly description: string | JSX.Element
	readonly ecoContent?: string
	readonly action?: ActionProps
	readonly alert?: JSX.Element
}
export function ContentContainer({
	description,
	ecoContent,
	action,
	alert,
}: ContentContainerProps) {
	return (
		<div className={cx(styles.container)}>
			{alert}
			{ecoContent && <p className={cx(styles.content)}>{ecoContent}</p>}
			<div
				className={clsx(
					styles.content,
					action ? styles.actionSpacer : styles.spacer
				)}
			>
				{description}
			</div>
			{action && (
				<Action
					text={action.text}
					className={action.className}
					dataTestId={action.dataTestId}
					onClick={action.onClick}
					isDisabled={action.isDisabled}
					{...(action?.linkAttributes && {
						linkAttributes: action.linkAttributes,
					})}
				/>
			)}
		</div>
	)
}
